import { RubricCriteriaCanvas } from '@/components/admin/evaluation-rubrics/rubric-criteria-canvas'
import { type RubricCriterion } from '@/hooks/use-evaluation-rubrics-admin'

type RubricDimensionsCanvasProps = {
  criteria: RubricCriterion[]
  skillOptions?: string[]
  onSave: (criteria: RubricCriterion[]) => void
  onClose: () => void
}

export function RubricDimensionsCanvas(props: RubricDimensionsCanvasProps) {
  return <RubricCriteriaCanvas {...props} kinds={['dimension']} />
}
